import React, { ReactNode } from 'react';

import MediaTypography from 'components/MediaTypography';

import {
	StyledGoBackHeaderArrowBack,
	StyledGoBackHeaderButton,
	StyledGoBackHeaderTitle,
	StyledGoBackHeaderWrap,
} from './styled';

type PropsType = {
	onGoBack?: () => void;
	title: string | ReactNode;
};

function GoBackHeader({ title, onGoBack }: PropsType) {
	const showGoBackSection = onGoBack && title;

	if (showGoBackSection) {
		return (
			<StyledGoBackHeaderWrap>
				<StyledGoBackHeaderButton onClick={onGoBack}>
					<StyledGoBackHeaderArrowBack color="primary" />
				</StyledGoBackHeaderButton>
				<StyledGoBackHeaderTitle variant="subtitle2" variants={{ sm: 'subtitle1' }}>
					{title}
				</StyledGoBackHeaderTitle>
			</StyledGoBackHeaderWrap>
		);
	}

	return title ? (
		<MediaTypography variant="h2" variants={{ sm: 'subtitle1' }}>
			{title}
		</MediaTypography>
	) : null;
}

export default GoBackHeader;
